/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDocumentType,
  createDynamicColumn,
  getDocumentTypeWithPagination,
  getDynamicColumn,
  getSubModulesByRoleId,
} from "../../../store";

// Date fns
import { addMinutes, format } from "date-fns";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const DocumentType = ({
  getDocumentTypeWithPagination,
  getDocumentTypeWithPaginationReducer,
  createDocumentType,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let subModuleId = "3c3f0eb3-6899-4a21-8bec-cc950a9a4967";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let documentTypeModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "3c3f0eb3-6899-4a21-8bec-cc950a9a4967",
  );

  let viewAccess = documentTypeModule
    ? documentTypeModule.actionId.includes(
        "cd59c5e2-2d0c-416e-9136-31e95e90b942",
      )
    : null;
  let createDocument = documentTypeModule
    ? documentTypeModule.actionId.includes(
        "5b8e7128-1737-4290-a4d3-09d3ee7b0caf",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Document Code", accessor: "documentCode", align: "left" },
      { Header: "Document Name", accessor: "documentName", align: "left" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  useEffect(() => {
    viewAccess &&
      getDocumentTypeWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempDocumentType = [];
    let data = getDocumentTypeWithPaginationReducer.documentType.data
      ? getDocumentTypeWithPaginationReducer.documentType.data
      : [];
    setPaginationObj(
      getDocumentTypeWithPaginationReducer?.documentType?.pagination,
    );
    setLoading(getDocumentTypeWithPaginationReducer.loading);
    data.map((document) => {
      // const formatDate = new Date(document.cd);
      const documentTypeObject = {
        documentCode: document.documentCode,
        documentName: document.documentName,
        cd: document.cd,
      };
      tempDocumentType.push(documentTypeObject);
    });
    setState({ ...state, rows: tempDocumentType });
  }, [getDocumentTypeWithPaginationReducer]);

  const [createDocumentModal, setCreateDocumentModal] = useState(false);

  const handleCreateDocumentModal = () => {
    setCreateDocumentModal(true);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };
  const handleCreateCloseDocumentModal = () => {
    setCreateDocumentModal(false);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  const initialValues = {
    documentCode: "",
    documentName: "",
  };

  const validationSchema = Yup.object({
    documentCode: Yup.string().required("Enter Document Code"),
    documentName: Yup.string().required("Enter a Document Name"),
  });
  const [isErrorMsgCreateDocument, setIsErrorMsgCreateDocument] = useState("");

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmit = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    const payload = {
      documentCode: values.documentCode.trim(),
      documentName: values.documentName.trim(),
    };

    let res = await createDocumentType(payload);

    if (res.status) {
      setIsSuccessCreateDocument(true);
      getDocumentTypeWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        setButtonName("Submit");
        handleCreateCloseDocumentModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorCreateDocument(true);
      setIsErrorMsgCreateDocument(res?.data?.data?.msg);
      setButtonName("Submit");
    }

    resetForm();
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessCreateDocument, setIsSuccessCreateDocument] = useState(false);
  const [isErrorCreateDocument, setIsErrorCreateDocument] = useState(false);

  useEffect(() => {
    if (isErrorCreateDocument) {
      setTimeout(() => {
        setIsErrorCreateDocument(false);
      }, 3000);
    }
  }, [isErrorCreateDocument]);

  useEffect(() => {
    if (isSuccessCreateDocument) {
      setTimeout(() => {
        setIsSuccessCreateDocument(false);
      }, 3000);
    }
  }, [isSuccessCreateDocument]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getDocumentTypeWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mt={-2}
            >
              <MDBox
                color="text"
                px={{ xs: 0.5, sm: 0.5, md: 2, lg: 2, xl: 2 }}
                style={{ marginLeft: "-15px" }}
              >
                {createDocument && (
                  <CreateButton
                    tooltip="Create Document Type"
                    // disabled={!createDocument}
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={(event) => handleCreateDocumentModal()}
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
              </MDBox>
            </MDBox>
            <MDBox mt={-3}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={createDocumentModal}
              onClose={handleCreateCloseDocumentModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Document
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCreateCloseDocumentModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6">Document Code</MDTypography>
                      <MDInput
                        type="text"
                        name="documentCode"
                        fullWidth
                        autoComplete="off"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.documentCode}
                        error={
                          formik.touched.documentCode &&
                          formik.errors.documentCode &&
                          true
                        }
                        inputProps={{
                          style: {
                            height: "10px",
                          },
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.documentCode &&
                        formik.errors.documentCode && (
                          <TextError msg={formik.errors.documentCode} />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6">Document Name</MDTypography>
                      <MDInput
                        type="text"
                        name="documentName"
                        fullWidth
                        autoComplete="off"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.documentName}
                        error={
                          formik.touched.documentName &&
                          formik.errors.documentName &&
                          true
                        }
                        inputProps={{
                          style: {
                            height: "10px",
                          },
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.documentName &&
                        formik.errors.documentName && (
                          <TextError msg={formik.errors.documentName} />
                        )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorCreateDocument}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorCreateDocument(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgCreateDocument}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessCreateDocument}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessCreateDocument(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Document created successfully
                        </Alert>
                      </Collapse>
                    </MDBox>

                    <MDBox mt={3}>
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={
                          !formik.isValid || buttonName === "Please wait..."
                        }
                      >
                        {buttonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </MDBox>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getDocumentTypeWithPaginationReducer:
      state.getDocumentTypeWithPaginationReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getDocumentTypeWithPagination: (
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getDocumentTypeWithPagination(
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    createDocumentType: (payload, jwtToken) =>
      dispatch(createDocumentType(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentType);
